import { request } from '../request'

// 获取首页轮播图列表
export function getImgList (data) {
    return request({
        url: '/website/indexImage',
        method: 'GET',
        data
    })
}

// 新增首页轮播图
export function handleAdd (data) {
    return request({
        url: '/website/indexImage',
        method: 'POST',
        data
    })
}

// 修改首页轮播图信息
export function handleEdit (data) {
    return request({
        url: '/website/indexImage',
        method: 'PUT',
        data
    })
}

// 获取首页轮播图信息详情
export function getImageInfo (data) {
    return request({
        url: '/website/indexImage/' + data.id,
        method: 'GET'
    })
}

// 删除首页轮播图
export function handleDelete (data) {
    return request({
        url: '/website/indexImage/' + data.id,
        method: 'DELETE'
    })
}

// 修改首页轮播图状态
export function editStatus (data) {
    return request({
        url: '/website/indexImage/modifyStatus/' + data.id + '?status=' + data.status,
        method: 'PUT'
    })
}

// 图片上传
export function imageUpload (data) {
    return request({
        url: '/website/attachment',
        method: 'POST',
        data
    })
}

// 获取图片超链接列表
export function getPictureList (data) {
    return request({
        url: '/website/imageLink',
        method: 'GET',
        data
    })
}

// 图片超链接新增
export function handleAddImage (data) {
    return request({
        url: '/website/imageLink',
        method: 'POST',
        data
    })
}

// 图片超链接修改设置
export function editSetting (data) {
    return request({
        url: '/website/imageLink',
        method: 'PUT',
        data
    })
}

// 获取图片超链接详情
export function getSettingInfo (data) {
    return request({
        url: '/website/imageLink/' + data.id,
        method: 'GET'
    })
}

// 图片超链接删除
export function deleteImage (data) {
    return request({
        url: '/website/imageLink/' + data.id,
        method: 'DELETE'
    })
}

// 修改图片超链接状态
export function editEnabled (data) {
    return request({
        url: '/website/imageLink/modifyEnabled/' + data.id + '?enabled=' + data.status,
        method: 'PUT'
    })
}
